export default __webpack_public_path__ + "static/media/rain-snow-showers-day.bbae52cb.svg";